import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default function convertDateToTimezone(
  inputDate: string | Date | Dayjs,
  timeZone: string
) {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (!inputDate || !timeZone) return null;
  const utcDate = dayjs.utc(inputDate);

  const convertedValue = utcDate.tz(timeZone);

  return convertedValue;
}
